export default "__VITE_ASSET__0B_7wEXb__"